import SmartFeedEngine from "SmartFeed/smart-feed-engine";
import { defineSmartFeedPiniaStore } from "@bloglovin/vue-framework";
import { SOCIAL_MEDIA_MANAGER } from "@/constants/expert-constants";

export const useOrgCommunitySocialMediaExpertiseFeedStore = defineSmartFeedPiniaStore(
  "org-community-social-media-expertise-feed-store",
  {
    state: () => ({
      smartFeedEngine: new SmartFeedEngine(),
      defaultFilterValues: {
        expertise: {
          key: "expertise",
          payload: SOCIAL_MEDIA_MANAGER,
        },
      },
      metadata: {
        lastId: Number.MAX_SAFE_INTEGER,
      },
    }),
    getters: {
      feedUrl() {
        return "/expert/community";
      },
    },
  },
);
